// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__5BXKW","Tooltip__arrow":"Tooltip_Tooltip__arrow__8rtp0","Tooltip__arrow__target":"Tooltip_Tooltip__arrow__target__Tgnp6"};